<script>
	import { navigate } from "svelte-routing";
	import { imageLightbox } from "../../../../../store/store";
	import { Table } from "sveltestrap";
	import CustomPaginate from "../../../../../components/CustomPaginate/Pagination.svelte";
	import LoaderContainer from "../../../../../components/Loader/LoaderContainer.svelte";
	import { FontAwesomeIcon } from "fontawesome-svelte";
	import { library } from "@fortawesome/fontawesome-svg-core";
	import { faPaperclip as fasPaperclip } from "@fortawesome/free-solid-svg-icons";
	import { convert } from "../../../../../services/helpers";
	import {
		VehicleReportSectionOptions,
		cmmDamageTypeOptions,
		VehicleCarSectionOptions,
	} from "../../../../../utils/options";
	export let data;
	library.add(fasPaperclip);

	//lightbox with image
	import Lightbox from "../../../../../components/Lightbox/Lightbox.svelte";

	let modalOpen = false;

	let imageShowingIndex = 0;

	const handleImgClick = (i) => {
		imageLightbox.set(i);
		imageShowingIndex = 0;
		modalOpen = true;
	};
</script>

{#if modalOpen}
	<Lightbox on:click={() => (modalOpen = false)} {imageShowingIndex} />
{/if}

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Vehicle No.</th>
				<th>Damage Area</th>
				<th>Damage Type</th>
				<th>Report Section</th>
				<th>Photos/Videos</th>
				<th>Date Reported</th>
				<th>Date Modified</th>
				<th>Source</th>
				<th>Status</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { vehicleId, reportSection, plateNumber, carSection, damageType, imageUrls, createdAt, updatedAt, originType }}
				<tr>
					<td>
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<p
							class="link"
							on:click={() =>
								navigate(
									`/car-management/details/${vehicleId}`
								)}
						>
							<span class="link link-text">
								{plateNumber}
							</span>
						</p>
					</td>
					<td>
						<p>
							<span>
								{VehicleCarSectionOptions[carSection] !=
								undefined
									? VehicleCarSectionOptions[carSection].label
									: undefined}
							</span>
						</p>
					</td>
					<td>
						{cmmDamageTypeOptions[damageType] != undefined
							? cmmDamageTypeOptions[damageType].label
							: "NA"}
					</td>
					<td>
						{VehicleReportSectionOptions[reportSection] != undefined
							? VehicleReportSectionOptions[reportSection].label
							: undefined}
					</td>
					<td>
						<h4 class="">
							&nbsp;&nbsp;
							<!-- svelte-ignore a11y-click-events-have-key-events -->
							<!-- svelte-ignore a11y-interactive-supports-focus -->
							<i
								role="button"
								on:click={() => handleImgClick(imageUrls)}
							>
								<FontAwesomeIcon icon={fasPaperclip} />
							</i>
						</h4>
					</td>
					<td>
						{convert(createdAt)}
					</td>
					<td>
						{#if updatedAt}
							{convert(updatedAt)}
						{:else}
							Never
						{/if}
					</td>
					<td>
						{#if originType === 0}
							FMS
						{:else if originType === 1}
							CMS
						{/if}
					</td>
					<td>
						<p class="status-bar status-bar-1">Approved</p>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.length === 0}
		<p class="text-center">No data to display</p>
	{/if}
	<CustomPaginate totalRecord={data.length} />
</LoaderContainer>
